import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { authService } from '../services/auth';
import { toast } from '../hooks/use-toast';
import { Toaster } from '../components/ui/toaster';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [username, setUsername] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(false);

    if (!username.trim()) {
      setError('Por favor ingresa tu usuario');
      setLoading(false);
      return;
    }

    try {
      const response = await authService.forgotPassword({ username: username.trim() });

      if (response.success) {
        setSuccess(true);
        toast({
          title: "Solicitud enviada",
          description: response.message || "Si el usuario existe, se enviará un correo con las instrucciones.",
        });
      }
    } catch (err) {
      const errorMessage = err.message || 'Error al solicitar recuperación de contraseña. Intenta nuevamente.';
      setError(errorMessage);
      toast({
        title: "Error",
        description: errorMessage,
        variant: "destructive",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-black px-6 py-8">
      <div className="max-w-md mx-auto">
        {/* Back button */}
        <button 
          onClick={() => navigate('/login')}
          className="flex items-center gap-2 text-white hover:text-[#A2A2A2] transition-colors mb-8"
        >
          <ArrowLeft className="w-5 h-5" />
          <span>Volver</span>
        </button>

        <div className="space-y-8">
          <div>
            <h1 className="text-4xl font-bold text-white mb-2">Recuperar contraseña</h1>
            <p className="text-[#A2A2A2]">Ingresa tu usuario para recibir un enlace de recuperación</p>
          </div>

          {success ? (
            <div className="space-y-6">
              <div className="bg-green-500/10 border border-green-500/50 rounded-2xl p-4">
                <p className="text-green-400 text-sm">
                  Si el usuario existe y tiene un correo electrónico válido, se enviará un enlace de recuperación a tu correo.
                </p>
              </div>
              <Button
                onClick={() => navigate('/login')}
                className="w-full bg-white text-black hover:bg-white/90 rounded-full py-6 text-lg font-medium transition-all hover:scale-105 active:scale-95"
              >
                Volver al login
              </Button>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="space-y-2">
                <Label htmlFor="username" className="text-white">Correo</Label>
                <Input
                  id="username"
                  name="username"
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  className="bg-white/5 border-white/10 text-white rounded-2xl h-12"
                  placeholder="Ingresa tu correo"
                  required
                  autoFocus
                />
              </div>

              {error && (
                <div className="bg-red-500/10 border border-red-500/50 rounded-2xl p-4">
                  <p className="text-red-400 text-sm">{error}</p>
                </div>
              )}

              <Button
                type="submit"
                disabled={loading}
                className="w-full bg-white text-black hover:bg-white/90 rounded-full py-6 text-lg font-medium transition-all hover:scale-105 active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {loading ? 'Enviando...' : 'Enviar'}
              </Button>
            </form>
          )}
        </div>
      </div>
      <Toaster />
    </div>
  );
};

export default ForgotPassword;

